import axios from 'axios';
import cookie from '../cookieHelper/cookie';

export default function authenticateUser() {
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);
    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/getProfile';

    return axios
        .get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`, 
            },
        })
        .then(res => {
            // console.log("Authentication successful: ", res.data);
            // Save the user profile data or handle it as needed
            const userProfile = res.data.data;
            cookie.setCookie('loginProfileInfo', JSON.stringify(userProfile), 2);
            // console.log("Saved profile info to cookies:", cookie.getCookie('loginProfileInfo'));
            return userProfile;
        })
        .catch(err => {
            // console.error("Error during authentication: ", err.response?.data || err.message);
            return err;
        });
}
